import React from "react";
import "../styles/AboutPage.css";

export default function AboutPage() {
  // TODO: uzupełnij docelowy e-mail
  const contactEmail = "siedzieje.kontakt@gmail.com";

  return (
    <div className="about-page">
      {/* HERO */}
      <section className="about-hero">
        <div className="container py-4 py-lg-5">
          <div className="row align-items-center g-4">
            <div className="col-12 col-lg-7">
              <div className="about-hero__badge">
                <i className="bi bi-stars me-2" />
                Siedzieje • O nas
              </div>
              
              <h1 className="about-hero__title mb-2">
                Łączymy ludzi z wydarzeniami, które naprawdę ich interesują
              </h1>

              <p className="about-hero__lead mb-4">
                Siedzieje to platforma do odkrywania wydarzeń – od koncertów i
                targów, po sport, kulturę i spotkania lokalne. Chcemy, aby
                znalezienie ciekawego wyjścia było szybkie, wygodne i
                przyjemne.
              </p>

              {/* <div className="d-flex flex-column flex-sm-row gap-2">
                <a href={`mailto:${contactEmail}`} className="btn btn-primary about-btn">
                  <i className="bi bi-envelope me-2" />
                  Napisz do nas
                </a>

                <a href="#about-content" className="btn btn-outline-light about-btn about-btn--ghost">
                  <i className="bi bi-arrow-down-circle me-2" />
                  Poznaj szczegóły
                </a>
              </div> */}
            </div>

            {/* <div className="col-12 col-lg-5">
              <div className="about-hero__card card border-0 shadow-sm rounded-4">
                <div className="card-body p-4 p-lg-4">
                  <div className="about-mini-stats">
                    <div className="about-mini-stats__item">
                      <div className="about-mini-stats__icon">
                        <i className="bi bi-compass" />
                      </div>
                      <div>
                        <div className="about-mini-stats__label">Misja</div>
                        <div className="about-mini-stats__value">
                          odkrywaj wydarzenia bez chaosu
                        </div>
                      </div>
                    </div>

                    <div className="about-mini-stats__divider" />

                    <div className="about-mini-stats__item">
                      <div className="about-mini-stats__icon">
                        <i className="bi bi-shield-check" />
                      </div>
                      <div>
                        <div className="about-mini-stats__label">Jakość</div>
                        <div className="about-mini-stats__value">
                          czytelne karty, jasne informacje
                        </div>
                      </div>
                    </div>

                    <div className="about-mini-stats__divider" />

                    <div className="about-mini-stats__item">
                      <div className="about-mini-stats__icon">
                        <i className="bi bi-lightning-charge" />
                      </div>
                      <div>
                        <div className="about-mini-stats__label">Prostota</div>
                        <div className="about-mini-stats__value">
                          szybkie filtrowanie i wyszukiwanie
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="about-hero__note mt-3">
                    Budujemy Siedzieje iteracyjnie – skupiamy się na UX, jakości danych
                    i realnej wartości dla użytkowników.
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* dekoracje */}
        <div className="about-hero__glow about-hero__glow--a" />
        <div className="about-hero__glow about-hero__glow--b" />
      </section>

      {/* CONTENT */}
      <section id="about-content" className="about-content">
        <div className="container py-4 py-lg-5">
          <div className="row g-4">
            {/* LEWA: główne sekcje */}
            <div className="col-12 col-lg-8">
              <div className="card border-0 shadow-sm rounded-4 about-card">
                <div className="card-body p-4 p-lg-5">
                  <div className="about-section">
                    <h2 className="about-h2">
                      <i className="bi bi-flag me-2" />
                      Nasza misja
                    </h2>
                    <p className="text-muted mb-0">
                      {/* TODO: uzupełnij opis */}
                      W Siedzieje porządkujemy świat wydarzeń. Zbieramy i prezentujemy je
                      w sposób, który pozwala szybko ocenić: co, gdzie, kiedy, dla kogo i
                      za ile, bez przeklikiwania się przez dziesiątki stron.
                    </p>
                    <p className="text-muted mb-0 mt-3">
                      Dla organizatorów tworzymy przestrzeń do dodatkowej promocji i trafiania do
                      nowych odbiorców, realnie zainteresowanych udziałem w ich wydarzeniach.
                    </p>
                    <p className="text-muted mb-0 mt-3">
                      Platforma jest darmowa i nie czerpie zysków z publikacji wydarzeń pobranych z internetu
                    </p>
                  </div>

                  <div className="about-divider" />

                  <div className="about-section">
                    <h2 className="about-h2">
                      <i className="bi bi-diagram-3 me-2" />
                      Skąd są wydarzenia?
                    </h2>
                    {/* <p className="text-muted mb-0">
                      
                      W Siedzieje gromadzimy publicznie dostępne w internecie informacje o wydarzeniach i porządkujemy je w przejrzyste kategorie, 
                      aby znalezienie czegoś interesującego było jak najprostsze. 
                    </p>
                    <p className="text-muted mb-0">
                        Nie zmieniamy treści ogłoszeń ani nie ingerujemy w ich szczegóły – wszystkie dane pochodzą z oficjalnych źródeł organizatorów.
                    </p>
                    <p className="text-muted mb-0">
                        Umożliwiamy również organizatorom publikowanie nowych wydarzeń bezpośrednio na platformie, do czego gorąco zachęcaymy. 
                    </p>
                    <div className="about-divider" />
                    <h2 className="about-h2 mt-4">
                      <i className="bi bi-diagram-3 me-2" />
                      Skąd są wydarzenia?
                    </h2>
                    <p className="text-muted mb-4">
                      Siedzieje nie jest organizatorem ani właścicielem publikowanych ogłoszeń. 
                      Przy każdym wydarzeniu wskazujemy organizatora oraz podajemy link do oryginalnej strony, na której znajdują się pełne i aktualne informacje.
                    </p> */}

                    <div className="about-steps">
                      <div className="about-step">
                        <div className="about-step__num">1</div>
                        <div>
                          <div className="about-step__title">Źródło</div>
                          <div className="about-step__desc text-muted">
                            {/* Przeglądasz wydarzenia, filtrujesz po kategoriach i lokalizacji. */}
                            W Siedzieje gromadzimy publicznie dostępne w internecie informacje o wydarzeniach i porządkujemy je w przejrzyste kategorie, 
                      aby znalezienie czegoś interesującego było jak najprostsze. 

                          </div>
                        </div>
                      </div>

                      <div className="about-step">
                        <div className="about-step__num">2</div>
                        <div>
                          <div className="about-step__title">Szczegóły wydarzeń</div>
                          <div className="about-step__desc text-muted">
                            <p>
                            Nie zmieniamy treści ogłoszeń ani nie ingerujemy w ich szczegóły – wszystkie dane pochodzą z oficjalnych źródeł organizatorów.
                            </p>
                            <p>
                            Treść ogłoszeń aktualizowana jest co 24 godziny, aby zapewnić jak największą aktualność informacji.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="about-step">
                        <div className="about-step__num">3</div>
                        <div>
                          <div className="about-step__title">Własność</div>
                            <div className="about-step__desc text-muted">
                              <p>
                                Siedzieje nie jest organizatorem ani właścicielem publikowanych ogłoszeń. 
                                Przy każdym wydarzeniu wskazujemy organizatora oraz podajemy link do oryginalnej strony, 
                                na której znajdują się pełne i aktualne informacje.
                              </p>
                              <p className="text-muted mb-0 mt-3">
                                Platforma jest darmowa i nie czerpiemy zysków z publikacji wydarzeń pobranych z internetu
                              </p>
                            </div>
                        </div>
                      </div>
                      <div className="about-step">
                        <div className="about-step__num">4</div>
                        <div>
                          <div className="about-step__title">Zgłaszanie naruszeń</div>
                            <div className="about-step__desc text-muted">
                                Przy każdym wydarzeniu znajduje się opcja zgłoszenia naruszenia. 
                                Jeśli zauważysz błąd lub nieprawidłowość w opisie wydarzenia, 
                                daj nam znać – skorygujemy lub usuniemy ogłoszenie.
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="about-divider" />

                  <div className="about-section">
                    <h2 className="about-h2">
                      <i className="bi bi-gem me-2" />
                      Co jest dla nas ważne
                    </h2>

                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <div className="about-pill">
                          <i className="bi bi-check2-circle me-2" />
                          {/* Przejrzystość informacji */}
                          Łatwość odkrywania wydarzeń
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="about-pill">
                          <i className="bi bi-check2-circle me-2" />
                          Przejrzystość informacji
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="about-pill">
                          <i className="bi bi-check2-circle me-2" />
                          Promocja wydarzeń
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="about-pill">
                          <i className="bi bi-check2-circle me-2" />
                          Wydarzenia blisko ludzi - bez względu na format
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="about-divider" />

                  <div className="about-section">
                    <h2 className="about-h2">
                      <i className="bi bi-chat-left-text me-2" />
                      Współpraca
                    </h2>
                    <p className="text-muted mb-3">
                      {/* TODO: uzupełnij */}
                      Jeśli organizujesz wydarzenia lub chcesz współpracować przy rozwoju
                      platformy - napisz. Jesteśmy otwarci i chętnie porozmawiamy o reklamie, integracjach, promocji i
                      partnerstwach.
                    </p>

                    <a href={`mailto:${contactEmail}`} className="about-mail">
                      <i className="bi bi-envelope me-2" />
                      {contactEmail}
                    </a>
                    <div className="about-divider" />
                  </div>
                  <div className="about-section">
                    <h2 className="about-h2">
                      Regulamin i polityka prywatności
                    </h2>

                      <div className="row g-3">
                        <div className="col-12 col-md-6">
                          <a
                            href="/regulamin-serwisu"
                            className="about-pill about-pill--link"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className="about-pill__left">
                              <span className="about-pill__icon">
                                <i className="bi bi-shield-check" />
                              </span>
                              <span className="about-pill__text">
                                <span className="about-pill__title">Regulamin serwisu</span>
                                <span className="about-pill__hint">Zasady korzystania i publikacji wydarzeń</span>
                              </span>
                            </span>

                            <span className="about-pill__right">
                              <i className="bi bi-arrow-up-right" />
                            </span>
                          </a>
                        </div>

                        <div className="col-12 col-md-6">
                          <a
                            href="/polityka-prywatnosci"
                            className="about-pill about-pill--link"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className="about-pill__left">
                              <span className="about-pill__icon">
                                <i className="bi bi-lock" />
                              </span>
                              <span className="about-pill__text">
                                <span className="about-pill__title">Polityka prywatności</span>
                                <span className="about-pill__hint">Dane osobowe, cookies techniczne i analityczne</span>
                              </span>
                            </span>

                            <span className="about-pill__right">
                              <i className="bi bi-arrow-up-right" />
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>

                </div>
              </div>
            </div>

            {/* PRAWA: kontakt + szybkie info */}
            <div className="col-12 col-lg-4">
              <div className="card border-0 shadow-sm rounded-4 about-card about-card--sticky">
                <div className="card-body p-4">
                  <h3 className="about-h3 mb-2">
                    <i className="bi bi-info-circle me-2" />
                    Kontakt
                  </h3>
                  <p className="text-muted small mb-3">
                    {/* TODO: ewentualny dopisek o czasie odpowiedzi */}
                    Pisz śmiało na sociale lub mail!
                  </p>

                  <div className="about-contact-box">
                    <div className="about-contact-box__row">
                      <div className="about-contact-box__icon">
                        <i className="bi bi-instagram" />
                      </div>
                      <div className="flex-grow-1">
                        <div className="about-contact-box__label">Instagram</div>
                        <a className="about-contact-box__value" href="https://www.instagram.com/sie_dzieje.pl/" target="_blank" rel="noreferrer">
                          sie_dzieje.pl
                        </a>
                      </div>
                    </div>
                    <div className="about-contact-box__row">
                      <div className="about-contact-box__icon">
                        <i className="bi bi-facebook" />
                      </div>
                      <div className="flex-grow-1">
                        <div className="about-contact-box__label">Facebook</div>
                        <a className="about-contact-box__value" href="https://www.facebook.com/profile.php?id=615842258126991" target="_blank" rel="noreferrer">
                          Siedzieje
                        </a>
                      </div>
                    </div>
                    <div className="about-contact-box__row">
                      <div className="about-contact-box__icon">
                        <i className="bi bi-envelope" />
                      </div>
                      <div className="flex-grow-1">
                        <div className="about-contact-box__label">E-mail</div>
                        <a className="about-contact-box__value" href={`mailto:${contactEmail}`}>
                          {contactEmail}
                        </a>
                      </div>
                    </div>

                    {/* <div className="about-contact-box__row">
                      <div className="about-contact-box__icon">
                        <i className="bi bi-clock" />
                      </div>
                      <div className="flex-grow-1">
                        <div className="about-contact-box__label">Status</div>
                        <div className="about-contact-box__value">
                          Budujemy i rozwijamy produkt
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div className="about-side-note mt-3">
                    {/* TODO: opcjonalnie polityka/zgłoszenia */}
                    Postaramy się odpisać tak szybko jak to możliwe
                  </div>

                  <div className="mt-4 d-grid gap-2">
                    <a href={`mailto:${contactEmail}`} className="btn btn-primary about-btn">
                      <i className="bi bi-send me-2" />
                      Napisz wiadomość
                    </a>
                    <a href="/" className="btn btn-outline-secondary about-btn">
                      <i className="bi bi-house-door me-2" />
                      Wróć na stronę główną
                    </a>
                  </div>
                </div>
              </div>

              {/* <div className="card border-0 shadow-sm rounded-4 mt-3 about-card about-card--subtle">
                <div className="card-body p-4">
                  <div className="d-flex gap-3">
                    <div className="about-subtle__icon">
                      <i className="bi bi-map" />
                    </div>
                    <div>
                      <div className="fw-semibold mb-1">Wydarzenia online i na żywo</div>
                      <div className="text-muted small mb-0">
                        Jedna platforma, dwa formaty – z czytelną informacją o lokalizacji.
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            {/* /prawa kolumna */}
          </div>
        </div>
      </section>
    </div>
  );
}
